/**
 * Adds the ACF rollover field image as a data-attribute to the native Featured
 * Image block
 *
 * TODO: Icon is featured image, but with a cursor overlaid
 */

import { SVG, Path } from "@wordpress/primitives";
import { registerBlockVariation } from "@wordpress/blocks";

import { addFilter } from "@wordpress/hooks";

const variationClassName = "post-featured-image-rollover";
const variationNamespace = `ideasonpurpose/${variationClassName}`;

const icon = "desktop";

export function rolloverHandler() {
  const rollovers = document.querySelectorAll(
    "figure.post-featured-image-rollover",
  );

  rollovers.forEach((fig) => {
    const src = fig.getAttribute("data-rollover-src");
    const srcset = fig.getAttribute("data-rollover-srcset");
    const img = fig.querySelector("a img");


    console.log({ src, srcset, img });

    if (img && src) {
      const hover = img.cloneNode();
      hover.setAttribute("alt", ""); // accessibility
      hover.setAttribute("src", src);
      hover.setAttribute("srcset", srcset);
      hover.classList.add("featured-image-rollover__hover");

      img.insertAdjacentElement("afterend", hover);
    }
  });
}

export function registerFeaturedImageRollover() {
  registerBlockVariation("core/post-featured-image", {
    name: variationClassName,
    title: "Featured Image (Rollover)",
    description: "Use the ACF Rollover field value as the rollover image.",
    isActive: ["namespace"],
    icon,

    attributes: {
      namespace: variationNamespace,
      className: variationClassName,

      /**
       * `useFirstImageFromPost` is too slow to use, it triggers a bunch of tag parsing that we don't need
       * @link https://github.com/WordPress/wordpress-develop/blob/d77bb088452293775e2f16225141ceff9994b171/src/wp-includes/blocks/post-featured-image.php#L68
       */
      useFirstImageFromPost: false,
      isLink: true,
      aspectRatio: "1.618/1",
      align: "wide",
      style: { spacing: { margin: { bottom: "var:preset|spacing|50" } } },
    },

    scope: ["inserter", "transform"],
  });

  addFilter(
    "blocks.registerBlockType",
    "ideasonpurpose.FeaturedImageRollover.RegisterBlockType",
    (settings, name) => {
      if (name !== "core/post-featured-image") {
        return settings;
      }

      const newSettings = { ...settings };

      newSettings.attributes = {
        ...newSettings.attributes,
        namespace: { type: "string", default: "" },
      };

      return newSettings;
    },
  );
}
